import { useCallback, useState } from 'react';
import { SkillStatus } from '../constants/statuses';
import { ROW_HEIGHT } from '../constants/table';
export var useHelpNeededFilter = function (containerRef) {
    var _a = useState(), filters = _a[0], setHelpNeededFilters = _a[1];
    var _b = useState(0), helpNeededCount = _b[0], setHelpNeededCount = _b[1];
    var _c = useState(0), paddingBottom = _c[0], setPadding = _c[1];
    var onSkillsLoad = useCallback(function (_a) {
        var students = _a.students;
        if (containerRef.current) {
            containerRef.current.style.paddingBottom = '';
        }
        var studentsNeedHelpCount = students.reduce(function (count, student) {
            if (student.skills.some(function (_a) {
                var status = _a.status;
                return status === SkillStatus.HelpNeeded;
            })) {
                count += 1;
            }
            return count;
        }, 0);
        if (students.length > studentsNeedHelpCount) {
            setPadding((students.length - studentsNeedHelpCount) * ROW_HEIGHT);
        }
        if ((filters === null || filters === void 0 ? void 0 : filters[0]) === 'true' && !studentsNeedHelpCount) {
            setHelpNeededFilters(undefined);
        }
        setHelpNeededCount(studentsNeedHelpCount);
    }, [containerRef, filters]);
    var onFilterChange = useCallback(function (checked) {
        if (checked) {
            setHelpNeededFilters(['true']);
            if (containerRef.current) {
                // Need to avoid page jumping when table reduced
                containerRef.current.style.paddingBottom = paddingBottom + "px";
            }
        }
        else {
            setHelpNeededFilters(undefined);
            if (containerRef.current) {
                containerRef.current.style.paddingBottom = '';
            }
        }
    }, [containerRef, paddingBottom]);
    return {
        filters: filters,
        helpNeededCount: helpNeededCount,
        onSkillsLoad: onSkillsLoad,
        onFilterChange: onFilterChange,
    };
};
